export enum UsageType {
  Free = 1,
  Paid = 2,
  Trial = 4,

  Other = 1024,
}

export enum ProductOrToolType {
  Client = 1,
  Web = 2,
  RevitAddin = 4,
  CivilAddin = 8,

  Other = 1024,
}

export enum CommandType {
  RevitCommand = 1,
  CivilCommand = 2,
  HiveCommand = 4,

  Other = 1024,
}

export enum LogType {
  BugFix = 1,
  NewFeature = 2,
  Enhancement = 3,
  Other = 1024,
}

export enum LicensingType {
  None = 1,
  Cloud = 2,
  Floating = 4,
  Trial = 8,
  NodeLocked = 16,

  Other = 1024,
}

export class EnumHelpers {
  public static GetLicensingType(type: number, includeValue: boolean = true) {
    let result: string = LicensingType[type];
    if (includeValue) {
      result += ` (${type})`;
    }
    return result;
  }
  public static GetLicensingTypeValue(typeString: string) {
    if (typeString.startsWith("None")) {
      return LicensingType.None;
    } else if (typeString.startsWith(LicensingType[LicensingType.Cloud])) {
      return LicensingType.Cloud;
    } else if (typeString.startsWith(LicensingType[LicensingType.Floating])) {
      return LicensingType.Floating;
    } else if (typeString.startsWith(LicensingType[LicensingType.Trial])) {
      return LicensingType.Trial;
    } else if (typeString.startsWith(LicensingType[LicensingType.NodeLocked])) {
      return LicensingType.NodeLocked;
    } else {
      return LicensingType.Other;
    }
  }
  public static GetFlaggedLicensingTypesValue(typeStrings: Array<string>) {
    let result: number = 0;
    typeStrings.forEach((typeString) => {
      result += this.GetLicensingTypeValue(typeString);
    });
    return result;
  }
  public static GetFlaggedLicensingTypes(
    type: number,
    includeValue: boolean = true
  ) {
    const types: Array<string> = [];
    if ((type & LicensingType.None) === LicensingType.None) {
      types.push(LicensingType[LicensingType.None]);
    }
    if ((type & LicensingType.Cloud) === LicensingType.Cloud) {
      types.push(LicensingType[LicensingType.Cloud]);
    }
    if ((type & LicensingType.Floating) === LicensingType.Floating) {
      types.push(LicensingType[LicensingType.Floating]);
    }
    if ((type & LicensingType.Trial) === LicensingType.Trial) {
      types.push(LicensingType[LicensingType.Trial]);
    }
    if ((type & LicensingType.NodeLocked) === LicensingType.NodeLocked) {
      types.push(LicensingType[LicensingType.NodeLocked]);
    }
    if ((type & LicensingType.Other) === LicensingType.Other) {
      types.push(LicensingType[LicensingType.Other]);
    }
    return types;
  }

  public static GetFlaggedLicensingTypesString(
    type: number,
    includeValue: boolean = true
  ) {
    let result: string = this.GetFlaggedLicensingTypes(type, includeValue).join(
      ", "
    );

    if (includeValue) {
      result += ` (${type})`;
    }

    return result;
  }
  public static GetUsageType(type: number, includeValue: boolean = true) {
    let result: string = UsageType[type];
    if (includeValue) {
      result += ` (${type})`;
    }
    return result;
  }
  public static GetUsageTypeValue(typeString: string) {
    if (typeString.startsWith("Free")) {
      return UsageType.Free;
    } else if (typeString.startsWith("Paid")) {
      return UsageType.Paid;
    } else if (typeString.startsWith("Trial")) {
      return UsageType.Trial;
    } else {
      return UsageType.Other;
    }
  }

  public static GetCommandType(type: number, includeValue: boolean = true) {
    let result: string;
    switch (type) {
      case CommandType.RevitCommand: {
        result = "Revit";
        break;
      }
      case CommandType.CivilCommand: {
        result = "Civil";
        break;
      }
      case CommandType.HiveCommand: {
        result = "Hive";
        break;
      }
      default: {
        result = CommandType[type];
        break;
      }
    }
    if (includeValue) {
      result += ` (${type})`;
    }
    return result;
  }
  public static GetCommandTypeValue(typeString: string) {
    if (typeString.startsWith("Revit")) {
      return CommandType.RevitCommand;
    } else if (typeString.startsWith("Civil")) {
      return CommandType.CivilCommand;
    } else if (typeString.startsWith("Hive")) {
      return CommandType.HiveCommand;
    } else {
      return CommandType.Other;
    }
  }

  public static GetLogType(type: number, includeValue: boolean = true) {
    let result: string;
    switch (type) {
      case LogType.BugFix: {
        result = "Bug Fix";
        break;
      }
      case LogType.NewFeature: {
        result = "New Feature";
        break;
      }
      default: {
        result = LogType[type];
        break;
      }
    }
    if (includeValue) {
      result += ` (${type})`;
    }
    return result;
  }
  public static GetLogTypeValue(typeString: string) {
    if (typeString.startsWith("Bug")) {
      return LogType.BugFix;
    } else if (typeString.startsWith("New")) {
      return LogType.NewFeature;
    } else if (typeString.startsWith("Enhancement")) {
      return LogType.Enhancement;
    } else {
      return LogType.Other;
    }
  }
  public static GetLogTypeName(typeString: string) {
    if (typeString.startsWith("Bug")) {
      return "Bug Fix";
    } else if (typeString.startsWith("New")) {
      return "New Feature";
    } else if (typeString.startsWith("Enhancement")) {
      return "Enhancement";
    } else {
      return "Other";
    }
  }

  public static GetProductOrToolType(
    type: number,
    includeValue: boolean = true
  ) {
    let result: string;
    switch (type) {
      case ProductOrToolType.RevitAddin: {
        result = "Revit Addin";
        break;
      }
      case ProductOrToolType.CivilAddin: {
        result = "Civil Addin";
        break;
      }
      default: {
        result = ProductOrToolType[type];
        break;
      }
    }
    if (includeValue) {
      result += ` (${type})`;
    }
    return result;
  }
  public static GetProductOrToolTypeValue(typeString: string) {
    if (typeString.startsWith(ProductOrToolType[ProductOrToolType.Client])) {
      return ProductOrToolType.Client;
    } else if (
      typeString.startsWith(ProductOrToolType[ProductOrToolType.Web])
    ) {
      return ProductOrToolType.Web;
    } else if (typeString.startsWith("Revit")) {
      return ProductOrToolType.RevitAddin;
    } else if (typeString.startsWith("Civil")) {
      return ProductOrToolType.CivilAddin;
    } else {
      return ProductOrToolType.Other;
    }
  }
  public static GetFlaggedProductOrToolTypeValue(typeStrings: Array<string>) {
    let result: number = 0;
    typeStrings.forEach((typeString) => {
      result += this.GetProductOrToolTypeValue(typeString);
    });
    return result;
  }
  public static GetFlaggedProductOrToolTypes(
    type: number,
    includeValue: boolean = true
  ) {
    const types: Array<string> = [];
    if ((type & ProductOrToolType.Client) === ProductOrToolType.Client) {
      types.push("Client");
    }
    if ((type & ProductOrToolType.Web) === ProductOrToolType.Web) {
      types.push("Web");
    }
    if (
      (type & ProductOrToolType.RevitAddin) ===
      ProductOrToolType.RevitAddin
    ) {
      types.push("Revit Addin");
    }
    if (
      (type & ProductOrToolType.CivilAddin) ===
      ProductOrToolType.CivilAddin
    ) {
      types.push("Civil Addin");
    }
    if ((type & ProductOrToolType.Other) === ProductOrToolType.Other) {
      types.push("Other");
    }
    return types;
  }
  public static GetFlaggedProductOrToolTypesString(
    type: number,
    includeValue: boolean = true
  ) {
    let result: string = this.GetFlaggedProductOrToolTypes(
      type,
      includeValue
    ).join(", ");

    if (includeValue) {
      result += ` (${type})`;
    }

    return result;
  }

  public static GetProductOrToolTypes() {
    const result: Array<string> = Object.values(ProductOrToolType)
      .filter((en) => !isNaN(Number(en)))
      .map((en) => this.GetProductOrToolType(Number(en), false));
    return result;
  }
  public static GetCommandTypes() {
    const result: Array<string> = Object.values(CommandType)
      .filter((en) => !isNaN(Number(en)))
      .map((en) => this.GetCommandType(Number(en), false));
    return result;
  }
  public static GetLogTypes() {
    const result: Array<string> = Object.values(LogType)
      .filter((en) => !isNaN(Number(en)))
      .map((en) => this.GetLogType(Number(en), false));
    return result;
  }
  public static GetUsageTypes() {
    const result: Array<string> = Object.values(UsageType)
      .filter((en) => !isNaN(Number(en)))
      .map((en) => this.GetUsageType(Number(en), false));
    return result;
  }
  public static GetLicensingTypes() {
    const result: Array<string> = Object.values(LicensingType)
      .filter((en) => !isNaN(Number(en)))
      .map((en) => this.GetLicensingType(Number(en), false));
    return result;
  }

  public static GetColor(type: number) {
    switch (type % 8) {
      case 0:
        return "black";
      case 1:
        return "blue";
      case 2:
        return "red";
      case 3:
        return "navy";
      case 4:
        return "green";
      case 5:
        return "brown";
      case 6:
        return "darkgrey";
      case 7:
        return "grey";
      default:
        return "orange";
    }
  }
}
